<template>
  <div>
    <el-dialog
      :title="readonly ? '客户筛选' : '批量打标签'"
      :visible.sync="dialogVisible"
      width="400"
      :before-close="dialogBeforeClose"
    >
      <div class="labels">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="label-lists"
        >
          <div class="label-title">
            {{ item.title }}
          </div>
          <SpLabelList
            :label-list="item.children"
            :tags-id="item.id"
            :selection-babel="true"
            :readonly="readonly"
          />
        </div>
      </div>
      <div
        slot="footer"
        class="batch-bottom"
      >
        <div>
          <el-button
            v-if="!readonly"
            type="text"
            @click="editLabelVisible = true"
          >
            新建标签组
          </el-button>
        </div>
        <div>
          <el-button @click="dialogBeforeClose">
            取 消
          </el-button>
          <el-button
            type="primary"
            @click="submitBatchLabel"
          >
            确 定
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 编辑组件 -->
    <SpEditLabel
      v-model="editLabelVisible"
      @submitLabel="submitLabel"
    />
  </div>
</template>

<script>
export default {
  name: 'SpBatchLabel',
  model: {
    prop: 'dialogVisible',
    event: 'changeDialogVisible'
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    readonly: {
      // 是否支持添加标签
      type: Boolean,
      default: false
    },
    selectionBabel: {
      // 是否支持标签选择
      type: Boolean,
      default: false
    },
    tagsList: {
      // 标签回显的数据
      type: Array
    },
    showSelectedTags: {
      // 是否展示已选择的标签（是否支持回显）
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      list: [],
      editLabelVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.init()
      }
    }
  },
  mounted () {
    if (this.dialogVisible) {
      this.init()
    }
  },
  methods: {
    async init () {
      const data = await this.$api.customer.getTagsList({
        page: 1,
        page_size: 999999
      })
      if (data) {
        // 可选标签的数据回显
        if (this.showSelectedTags && this.tagsList && this.tagsList.length > 0) {
          data.list.forEach((v) => {
            v.children &&
              v.children.forEach((vv) => {
                if (this.tagsList.findIndex((item) => item.id === vv.id) !== -1) {
                  vv.selected = true
                }
              })
          })
        }
        this.list = data.list
      }
    },
    dialogBeforeClose () {
      this.$emit('changeDialogVisible', false)
    },
    submitLabel () {
      this.init()
      this.editLabelVisible = false
    },
    submitBatchLabel () {
      let selectBabelList = []
      this.list.forEach((v) => {
        v.children &&
          v.children.forEach((item) => {
            if (item.selected) {
              selectBabelList.push(item)
            }
          })
      })

      this.$emit('selectBabelList', selectBabelList)
    }
  }
}
</script>

<style lang="scss" scoped>
.labels {
  max-height: 500px;
  overflow: auto;
}
.label-lists {
  margin-bottom: 12px;
  .label-title {
    margin-bottom: 6px;
    line-height: 22px !important;
  }
}
.batch-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
